import { FC } from 'react';
import { useFeatureTranslation, useValueTranslation } from '../../shared/translations/useFeatureTranslations';
import { Tooltip } from '../../shared/components/Tooltip';
import { InfoCircle } from '../../shared/components/InfoCircle';
import { DangerousHTML } from '../../shared/components/DangerousHTML';

export type ProductProperty = {
  Feature: string;
  FeatureID: string;
  Value: string;
  Unit?: string;
  ValueID: string;
  Tooltip: string;
  Sorter: number;
};

type ProductSpecificationProps = {
  property: ProductProperty;
};

export const ProductSpecification: FC<ProductSpecificationProps> = ({ property }) => {
  const { title, tooltip, unit: translationUnit } = useFeatureTranslation(property.FeatureID, property.Feature);
  const unit = translationUnit || property.Unit || '';

  const propertyTooltip = tooltip || property.Tooltip;

  const values = useValueTranslation(property.ValueID, property.FeatureID, {
    defaultValues: property.Value ? property.Value.split(',') : undefined,
    fetchTooltips: true,
  });

  return (
    <>
      <div className="product-specifications__feature is-col-6 is-col-2-lg">
        {title}
        {unit ? ` (${unit})` : null}
        {propertyTooltip && (
          <span style={{ marginLeft: 8 }}>
            <Tooltip tooltipAnchor={<InfoCircle />} tooltipContent={<DangerousHTML content={propertyTooltip} />} />
          </span>
        )}
      </div>
      <div className="product-specifications__value is-col-6 is-col-3-lg">
        {values.map((value, index) => {
          return (
            <>
              {index > 0 ? ', ' : null}
              {value.name}
              {value.tooltip && (
                <span style={{ marginLeft: 8 }}>
                  <Tooltip tooltipAnchor={<InfoCircle />} tooltipContent={<DangerousHTML content={value.tooltip} />} />
                </span>
              )}
            </>
          );
        })}
      </div>
    </>
  );
};
